import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import useExperimentVariant from 'hooks/useExperimentVariant';

import { PRICE_COMPARATOR_REDESIGN_EXPERIMENT_ID } from 'lib/experiment';
import placeholder from 'lib/placeholder';

import PromobitRowCard from './PromobitRowCard';
import StoresRowCard from './StoresRowCard';

const OfferComparator = ({
  gaEventCategory,
  isPromobitHasTheBestPrice = false,
  offerId,
  offersToCompare,
  offerCoupon,
  offerCta,
  offerPrice,
  offerSlug,
  offerUserVisibility,
}) => {
  const [isPriceComparatorRedesign] = useExperimentVariant(
    PRICE_COMPARATOR_REDESIGN_EXPERIMENT_ID,
    [false, true],
    {
      fallback: { outOfDateValue: false, beforeExperimentLoadValue: false },
    }
  );

  return (
    <section className="mb-8 flex flex-col gap-y-4 lg:mb-16">
      <Heading className="mb-2" size="size4">
        {placeholder('titles.compareToOtherOffers')}
      </Heading>
      {isPriceComparatorRedesign && (
        <PromobitRowCard
          gaEventCategory={gaEventCategory}
          isPromobitHasTheBestPrice={isPromobitHasTheBestPrice}
          offerCoupon={offerCoupon}
          offerCta={offerCta}
          offerId={offerId}
          offerPrice={offerPrice}
          offerSlug={offerSlug}
          offerUserVisibility={offerUserVisibility}
        />
      )}
      {offersToCompare.map(
        ({ id, price, redirect, store: { image, name } }) => (
          <StoresRowCard
            key={id}
            gaEventCategory={gaEventCategory}
            isPriceComparatorRedesign={isPriceComparatorRedesign}
            isPromobitHasTheBestPrice={isPromobitHasTheBestPrice}
            offerCompareId={id}
            offerId={offerId}
            offerPrice={price}
            redirectUrl={redirect}
            storeImage={image}
            storeName={name}
          />
        )
      )}
    </section>
  );
};

OfferComparator.displayName = 'OfferComparator';

OfferComparator.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isPromobitHasTheBestPrice: PropTypes.bool,
  offerId: PropTypes.number.isRequired,
  offersToCompare: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      redirect: PropTypes.string.isRequired,
      created: PropTypes.string.isRequired,
      store: PropTypes.shape({
        domain: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
};

export default OfferComparator;
